export default __webpack_public_path__ + "static/media/dasdasdassda 1.706c1a66.png";